<template>
  <div :class="['lr-modal', {'hide': !show}]">
    <div class="lr-box lyft-box">
      <div v-if="loading" class="load-box">
        <img src="https://www.opoli.com/wp-content/themes/opoli/img/loading-car.gif" />
        <div class="lyft-msg" v-html="msg"></div>
        <!-- <a :class="['button cta small block secondary', {disabled: !searching}]" @click="cancelRide">CANCEL</a> -->
      </div>

      <div v-else-if="driver.found" class="driver-box">
        <div class="db-title">Driver Found!</div>
        <div class="ride-id">
          Ride ID:
          <b>{{ rideId }}</b>
        </div>
        <div class="d-info-box d-flex">
          <img :src="driver.img" />
          <div>
            <div class="di-field name">{{ driver.name }}</div>
            <!-- <div class="di-field"><i class="far fa-id-card fa-fw" title="ID"></i> {{ driver.id }}</div> -->
            <div class="di-field"><i class="fas fa-phone-square fa-fw" title="mobile"></i> {{ driver.mobile }}</div>
            <div class="di-field"><i class="fas fa-star fa-fw" title="rating"></i> {{ driver.rating }}</div>
          </div>
        </div>
        <div class="d-info-box d-flex">
          <img :src="vehicle.img" />
          <div>
            <div class="di-field name">{{ `${vehicle.color} ${vehicle.make} ${vehicle.model} ${vehicle.year}` }}</div>
            <div class="di-field">{{ vehicle.licensePlate }}</div>
          </div>
        </div>
        <a class="button cta small block secondary" @click="show = false">CLOSE</a>
      </div>

      <div v-else-if="venueShow" class="pi-box">
        <div class="pi-header">Pickup Instruction</div>
        <div class="direction">{{ directions }}</div>
        <div v-if="zones.length > 1" class="pi-field">
          <label>Choose a pickup zone</label>
          <select v-model="zoneIndex">
            <option v-for="(x, i) in zones" :key="i" :value="i">{{ x.name }}</option>
          </select>
        </div>
        <div v-if="zones.length && zones[zoneIndex].locations.length" class="pi-field">
          <label>Choose a pickup location</label>
          <select v-model="locationIndex">
            <option v-for="(x, i) in zones[zoneIndex].locations" :key="i" :value="i">{{ x.name }}</option>
          </select>
        </div>
        <div class="pi-action d-flex justify-space-between">
          <a class="button cta small block secondary" @click="venueShow = false">BACK</a>
          <a class="button cta small block" @click="updatePickup">SEND</a>
        </div>
      </div>

      <div v-else>
        <div class="lr-head d-flex justify-space-between align-center">
          <div>Lyft Services</div>
          <div class="lrh-price">
            <span>Original Price</span>
            <b>${{ lyft.originalFare }}</b>
          </div>
        </div>
        <div class="lr-sub-head">
          <span>Original Service:</span>
          <b>{{ lyft.originalService }}</b>
        </div>
        <div class="lyft-service-box">
          <div :class="['lyft-service d-flex justify-space-between align-start', {failed: service.failed, active:selected && selected.ride_type === service.ride_type}]" v-for="(service, i) in services" :key="i" @click="select(service, i)">
            <div class="l-img">
              <img :src="service.custom_image" />
            </div>
            <div class="l-name">
              <div class="l-display-name">{{ service.display_name }}</div>
              <div class="l-service-code">{{ service.ride_type }}</div>
              <div class="l-eta" v-if="service.pickup_estimate && service.pickup_estimate.duration">
                <span>ETA in </span>
                <b>{{ getETA(service.pickup_estimate) }}</b>
              </div>
            </div>
            <div class="l-price">
              <small>Up to</small>
              <span :class="priceDiffClass(lyft.originalFare, service.estimated_cost_cents_max)">${{ price(service.estimated_cost_cents_max) }}</span>
            </div>
          </div>
        </div>
        <div class="pi-action d-flex justify-space-between">
          <a class="button cta small block secondary" @click="show = false">CANCEL</a>
          <a class="button cta small block" @click="checkVenue">SEND</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'lyft-services',
  data () {
    return {
      queue: [],
      selected: null,
      availability: {
        loading: false,
        status: '',
        token: ''
      },
      loading: false,
      msg: '',
      statusDelay: '',
      rideId: '',
      driver: {
        found: false,
        id: '',
        img: '',
        name: '',
        mobile: '',
        rating: ''
      },
      vehicle: {
        img: '',
        color: '',
        licensePlate: '',
        make: '',
        model: '',
        year: '',
      },
      currentRsvpID: '',
      searching: false,
      cancelSearch: false,

      // venues
      directions: '',
      zones: [],
      zoneIndex: 0,
      locationIndex: 0
    }
  },
  computed: {
    dispatch () { return this.$store.state.dispatch },
    lyft () { return this.dispatch.lyft },
    show: {
      get () { return this.lyft.show },
      set (x) {
        this.$store.commit('dispatch/setLyftData', {show: x})
        if (!x) {
          this.queue = []
          this.selected = null
        }
      }
    },
    services () {
      return this.lyft.services.filter(x => x.can_request_ride).sort((a, b) => a.estimated_cost_cents_max - b.estimated_cost_cents_max)
    },
    venue () { return this.dispatch.venue },
    venueShow: {
      get () { return this.venue.show },
      set (x) { this.$store.commit('dispatch/setVenueData', {show: x}) }
    },
    rsvpInTable () { return this.dispatch.rsvpInTable }
  },
  methods: {
    price (x) {
      var a = parseFloat(x)
      a = a / 100
      return a.toLocaleString('en-US', {minimumFractionDigits: 2})
      // if (x.estimated_cost_cents_min === x.estimated_cost_cents_max) return `$${(x.estimated_cost_cents_min / 100).toFixed(2)}`
      // return `$${(x.x.estimated_cost_cents_min / 100).toFixed(2)} - $${(x.estimated_cost_cents_max / 100).toFixed(2)}`
    },
    select (service, i) {
      // if (service.failed) return
      this.selected = service
    },
    send (pickup = null) {
      let self = this
      if (self.selected === null || self.availability.loading) return
      self.cancelSearch = false
      let rsvps = self.dispatch.checkedReservations

      let service = self.selected
      // self.$store.commit('global/setLoaderData', {show: true})
      self.loading = true
      self.msg = 'Processing your booking. . .'
      self.currentRsvpID = rsvps[0].id
      let param = {
        token: self.$store.state.session.sessionToken,
        ride_type: service.ride_type,
        cost_token: service.cost_token
        // driver_availability_token: self.availability.token
      }
      if (pickup) param.pickup = pickup
      self.$sdk.post(`/admin/rsvp/${rsvps[0].id}/lyft/create/asap`, param, r => {
        // self.$store.commit('global/setLoaderData', {show: false})
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          })
          self.loading = false
          self.show = false
          return
        }

        // self.$store.commit('global/setAlertData', {
        //   show: true,
        //   message: 'Successfully sent to Lyft.'
        // })
        // self.show = false
        self.msg = 'Searching for nearby drivers. . .'
        self.searching = true
        self.getStatus(rsvps[0].id)
      }, '1.1')
    },
    getStatus (rsvpId) {
      let self = this
      if (self.cancelSearch) return

      self.currentRsvpID = rsvpId
      self.$sdk.get(`/admin/rsvp/${rsvpId}/lyft`, {
        token: self.$store.state.session.sessionToken
      }, r => {
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          })
          self.loading = false
          self.show = false
          return
        }
        if (r.lyft || r.status === 'accepted') {
          self.searching = false
          let driver = r.lyft.driver
          let vehicle = r.lyft.vehicle
          self.rideId = r.rideId
          self.loading = false
          if (driver) {
            self.driver = {
              found: true,
              id: driver.id,
              img: driver.image_url,
              name: driver.first_name,
              mobile: driver.phone_number,
              rating: driver.rating
            }
          }
          if (vehicle) {
            self.vehicle = {
              img: vehicle.image_url,
              color: vehicle.color,
              licensePlate: vehicle.license_plate,
              make: vehicle.make,
              model: vehicle.model,
              year: vehicle.year
            }
          }
          return
        }

        if (self.statusDelay) clearTimeout(self.statusDelay)
        self.statusDelay = setTimeout(() => {
          self.getStatus(rsvpId)
        }, 5000)
      }, '1.1')
    },
    cancelRide () {
      let self = this
      if (!self.searching) return

      self.cancelSearch = true
      self.loading = true
      self.msg = 'Cancelling. . .'
      if (this.statusDelay) clearTimeout(this.statusDelay)
      self.$sdk.post(`/admin/rsvp/${self.currentRsvpID}/lyft/cancel`, {
        token: self.$store.state.session.sessionToken
      }, r => {
        self.show = false
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          })
          return
        }
      }, '1.1')
    },
    priceDiffClass (orig, newPrice) {
      orig = orig ? parseFloat(orig.toFixed(2)) : 0
      newPrice = newPrice ? parseFloat((newPrice / 100).toFixed(2)) : 0

      if (orig > newPrice) return 'low-price'
      if (orig < newPrice) return 'high-price'
      return ''
    },
    getETA (service = null) {
      if (service === null || !service) return false
      let eta = parseInt(service.duration)
      if (eta == 0) return '0 secs'
      let min = Math.ceil(parseFloat((eta / 60).toFixed(2)))
      let hour = 0
      if (min < 60) return `${min}min(s) `
      else {
        hour = Math.floor(parseFloat((min / 60).toFixed(2)))
        min = (hour * 60) - min
        return `${hour}hr(s) ${min}min(s)`
      }
    },
    checkVenue () {
      let self = this

      let origPrice = parseFloat(self.lyft.originalFare)
      let limitPercent = parseFloat(this.$settings.get('LyftDispatchRestrictPercent') || 10)
      let xlimitPercent = (limitPercent / 100) + 1
      let limitPrice = parseFloat((origPrice * xlimitPercent).toFixed(2))
      let servicePrice = parseFloat((self.selected.estimated_cost_cents_max / 100).toFixed(2))
      if (servicePrice > limitPrice) {
        self.$store.commit('global/setAlertData', {
          show: true,
          message: `This service exceeds the ${limitPercent}% fare limit for this reservation. The maximum allowed fare is $${limitPrice}.`
        })
        return
      }

      let rsvpData = self.rsvpInTable.find(x => x.id === self.dispatch.checkedReservations[0].id)
      let pickup = rsvpData.pickup
      let chk = self.venue.list.find(x => x.lat === pickup.lat && x.lng === pickup.lng)
      if (chk) {
        self.$store.commit('global/setLoaderData', {show: false})
        self.$store.commit('dispatch/setVenueData', {show: true})
        return
      }

      let request = {
        lat: pickup.lat,
        lng: pickup.lng,
        type: 'pickup',
        radius: 0.01
      }
      self.$store.commit('global/setLoaderData', {show: true})
      self.$sdk.get('/venues', request, res => {
        if (res.error ||
          (res.venues && !res.venues.length) ||
          (res.venues && res.venues.length && !res.venues[0].zones.length)
        ) {
          self.$store.commit('global/setLoaderData', {show: false})
          // self.proceedToCustomer()
          self.send()
          return
        }

        if (res.venues[0].category === 'airport') {
          self.$sdk.get('/geofences', {lat: pickup.lat, lng: pickup.lng}, res2 => {
            if (res2.error || (!res2.error && res2.list && res2.list[0] && res2.list[0].type !== 'airport')) {
              self.$store.commit('global/setLoaderData', {show: false})
              // self.proceedToCustomer()
              self.send()
              return
            }
            self.processVenueData(res, request)
          }, '1.1')
          return
        }

        self.processVenueData(res, request)
      }, '2.0')
    },
    processVenueData (res, request) {
      let self = this
      let tmpData = {
        name: res.venues[0].name,
        lat: request.lat,
        lng: request.lng,
        zones: []
      }
      res.venues[0].zones.forEach(x => {
        let tmpLocs = []
        x.locations.forEach(y => {
          tmpLocs.push({
            lat: y.lat,
            lng: y.lng,
            name: y.name,
            directions: self.lyftSanitize(y.walking_directions),
            disabled: y.disabled_ride_types
          })
        })
        tmpData.zones.push({
          name: x.name,
          directions: self.lyftSanitize(x.walking_directions),
          locations: tmpLocs
        })
      })
      self.$store.commit('dispatch/addVenueList', tmpData)
      self.$store.commit('global/setLoaderData', {show: false})
      self.$store.commit('dispatch/setVenueData', {show: true})
    },
    lyftSanitize (x) {
      if (!x) return x
      return x.replaceAll('Lyft', '').replaceAll('lyft', '').replaceAll('  ', ' ')
    },
    getDefaultVenue () {
      let self = this
      let rsvpData = self.rsvpInTable.find(x => x.id === self.dispatch.checkedReservations[0].id)
      let pickup = rsvpData.pickup
      let selectedLyftService = self.selected.ride_type
      if (!self.venue.list.length || !selectedLyftService) {
        console.log('empty venue or no selected service')
        self.send()
        // self.$emit('next')
        return
      }

      let data = self.venue.list.find(x => x.lat === pickup.lat && x.lng === pickup.lng)
      if (!data) {
        console.log('cannot find venue')
        self.send()
        // self.$emit('next')
        return
      }

      let selectedService = selectedLyftService
      if (selectedService === 'lyft_easy_step_in' || selectedService === 'lyft_priority_pickup') {
        selectedService = 'lyft'
      }

      data.zones.forEach(x => {
        let locations = []
        x.locations.forEach(y => {
          if (!y.disabled.includes(selectedService)) locations.push(y)
        })
        if (locations.length) {
          self.zones.push({
            name: x.name,
            directions: x.directions,
            locations: locations
          })
        }
      })
      if (!self.zones.length) {
        console.log('selected service is not allowed in any locations')
        self.send()
        // self.$emit('next')
        return
      }
      self.directions = self.zones[0].locations[0].directions
    },
    updatePickup () {
      let self = this
      let rsvpData = self.rsvpInTable.find(x => x.id === self.dispatch.checkedReservations[0].id)
      let pickup = rsvpData.pickup
      let pickupCopy = JSON.parse(JSON.stringify(pickup))
      self.$store.commit('dispatch/setVenueData', {
        lastCoords: `${pickup.lat},${pickup.lng}`,
        origPickupData: pickupCopy,
        selected: {
          service: rsvpData.serviceId,
          zone: self.zoneIndex,
          location: self.locationIndex
        }
      })

      let tmpPickup = JSON.parse(JSON.stringify(pickup))
      let data = self.venue.list.find(x => x.lat === pickup.lat && x.lng === pickup.lng)
      setTimeout(() => {
        tmpPickup.title = data.name + ', ' + self.zones[self.zoneIndex].name + ' ' + self.zones[self.zoneIndex].locations[self.locationIndex].name
        // tmpPickup.address1 = data.name
        // tmpPickup.address2 = self.zones[self.zoneIndex].name + ' ' + self.zones[self.zoneIndex].locations[self.locationIndex].name
        tmpPickup.lat = self.zones[self.zoneIndex].locations[self.locationIndex].lat
        tmpPickup.lng = self.zones[self.zoneIndex].locations[self.locationIndex].lng
        // self.$store.commit('reservation/setPickup', {
        //   leg: 'leg1',
        //   value: tmpPickup
        // })
        self.venueShow = false
        // self.$emit('next')
        self.send({
          address: tmpPickup.title,
          lat: tmpPickup.lat,
          lng: tmpPickup.lng
        })
      }, 50)
    }
  },
  watch: {
    show (x) {
      if (!x) {
        if (this.statusDelay) clearTimeout(this.statusDelay)
        this.driver.found = false
        this.cancelSearch = true
      } else {
        this.cancelSearch = false
        this.zones = []
        this.directions = ''
        this.zoneIndex = 0
        this.locationIndex = 0
      }
    },
    venueShow (x) {
      let self = this
      if (x) {
        let rsvpData = self.rsvpInTable.find(x => x.id === self.dispatch.checkedReservations[0].id)
        let pickup = rsvpData.pickup
        if (this.venue.lastCoords === `${pickup.lat},${pickup.lng}` && this.venue.selected.service === rsvpData.serviceId) {
          this.zoneIndex = this.venue.selected.zone
          setTimeout(() => {
            self.locationIndex = this.venue.selected.location
            self.getDefaultVenue()
          }, 50)
          return
        }
        this.zones = []
        this.directions = ''
        this.zoneIndex = 0
        this.locationIndex = 0
        this.getDefaultVenue()
      } else {
        this.zones = []
        this.directions = ''
        this.zoneIndex = 0
        this.locationIndex = 0
      }
    },
    zoneIndex (x) {
      this.locationIndex = 0
      if (!this.zones.length) {
        this.directions = ''
        return
      }
      this.directions = this.zones[x].locations[this.locationIndex].directions
    },
    locationIndex (x) {
      if (!this.zones.length) {
        this.directions = ''
        return
      }
      this.directions = this.zones[this.zoneIndex].locations[x].directions
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.lr-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.35);
  overflow: auto;
  opacity: 1;
  display: flex;
  justify-content: center!important;
  align-items: center!important;
  -webkit-transition: all 0.2s ease-in;
  -moz-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;

  &.hide {
    top: -100%;
    opacity: 0;
  }
}
.lr-box {
  background: #fff;
  padding: 20px;
  border-radius: 6px;
  box-shadow: 3px 3px 2px rgba(0,0,0, .3);
  text-align: center;
}
.lyft-box{
  width: 400px;
  line-height: 1;
}
.l-head{
  margin-bottom: 20px;
}
.lr-head{
  font-size: 24px;
  font-weight: 600;
  letter-spacing: .8px;
  margin-bottom: 15px;
}
.lrh-price{
  text-align: right;
  span{
    display: block;
    font-size: 12px;
    color: #797979;
    font-weight: 500;
  }
  b{
    font-size: 18px;
    line-height: 1;
  }
}

.lr-sub-head{
  text-align: center;
  margin-bottom: 10px;
  font-size: 13px;
  color: #444;
  letter-spacing: .6px;
}

.l-availability{
  font-size: 13px;
  letter-spacing: .7px;
  gap: 5px;
  color: #333;

  .status{
    width: 15px;
    height: 15px;
    border-radius: 100%;
    display: inline-block;

    &.GREEN{
      background: #38d944;
    }
    &.RED{
      background: #ff3f3f;
    }
    &.ORANGE{
      background: #ff983f;
    }
  }
  i{
    font-size: 21px;
    color: #ff1515;
  }
  .fa-spinner{
    color: #777;
  }
}

.lyft-service-box{
  overflow: auto;
  height: calc(100vh - 200px);
  margin-bottom: 20px;
  border: 1px solid #ccc;
  background: #f6f6f6;
  padding: 10px;
  border-radius: 4px;
}
.lyft-service{
  gap: 10px;
  border: 1px solid #ccc;
  margin-bottom: 10px;
  padding:10px;
  text-align: left;
  background: #fafafa;
  cursor: pointer;
  border-radius: 2px;
  box-shadow: 1px 1px 1px rgba(0,0,0, .1);

  &.active{
    outline: 2px solid #00a1ff;
    border-color: #195c83;
  }
  &.failed{
    opacity: .5;
    cursor: default;
  }
  &:not(.failed):hover{
    background: #fff;
  }
}

.l-img img{
  width: 60px;
}
.l-name{
  font-size: 16px;
  letter-spacing: .6px;
  width: calc(100% - 100px);
}
.l-display-name{
  font-weight: 600;
}
.l-service-code{
  font-size: 11px;
  color: #999;
  margin-top: 5px;
}
.l-eta{
  margin: 10px 0 0;
  letter-spacing: .6px;
  font-size: 13px;
  color: #333;

  b{
    display: inline-block;
    margin-left: 2px;
  }
}
.l-failed-txt{
  font-size: 12px;
  color: #f00;
  margin-top: 5px;
  letter-spacing: .8px;
}
.l-price{
  letter-spacing: .8px;
  text-align: right;
  small{
    font-size: 12px;
    line-height: 1;
    display: block;
    margin-bottom: 3px;
    color: #797979;
  }
  span{
    display: block;
    font-weight: 600;
    color: #364560;

    &.low-price{
      color: #29a53a;
    }
    &.high-price{
      color: #a52929;
    }
  }
}

.btn-send{
  margin: 10px 0;
}

.driver-box{
  .db-title{
    font-size: 24px;
    font-weight: 600;
    letter-spacing: .8px;
    margin-bottom: 20px;
  }
  .ride-id{
    text-align: left;
    font-size: 14px;
    color: #444;
    margin-bottom: 5px;

    b{
      margin-left: 5px;
      letter-spacing: .6px;
    }
  }
  .d-info-box{
    border: 1px solid #ccc;
    padding: 10px;
    background: #fafafa;
    gap: 15px;
    align-items: start;
    margin-bottom: 15px;

    img {
      width: 100px;
      border: 1px solid #eee;
    }
  }
  .di-field{
    text-align: left;
    letter-spacing: .6px;
    color: #555;
    font-size: 13px;
    margin-bottom: 6px;
    font-weight: 600;
    
    &.name{
      color: #333;
      font-size: 16px;
    }
    i{
      font-size: 16px;
      color: #aaa;
      margin-right: 1px;
      vertical-align: -1px;
    }
  }
}

.load-box{
  .lyft-msg{
    color: #888;
    font-size: 15px;
    letter-spacing: .6px;
    font-style: italic;
    margin: 10px 0 30px;
  }
}

.pi-box{
  .pi-header{
    font-size: 18px;
    font-weight: 600;
    letter-spacing: .5px;
    color: #333;
    border-bottom: 1px solid #ddd;
    padding-bottom: 10px;
    margin-bottom: 10px;
  }
  .direction{
    text-align: left;
    letter-spacing: .4px;
    font-size: 15px;
    line-height: 1.2;
    margin-bottom: 20px;
    color: #555;
  }
  .pi-field{
    text-align: left;

    label{
      font-size: 14px;
      letter-spacing: .6px;
      margin-bottom: 3px;
      display: block;
    }
    select{
      background: #f7f7f7;
      padding: 5px;
      margin-bottom: 20px;
      box-shadow: 0 0 2px rgba(0, 0, 0, .4);
      outline: none;
    }
  }
}
.pi-action{
  gap: 20px
}
</style>



// WEBPACK FOOTER //
// src/components/Dispatch/LyftServices.vue